export default __webpack_public_path__ + "static/media/logo_image_small.b6788a75.png";